var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:linkedin",
    clipPath: "url(#clip0_1479_29611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 3C28.7956 3 29.5587 3.31607 30.1213 3.87868C30.6839 4.44129 31 5.20435 31 6V27C31 27.7956 30.6839 28.5587 30.1213 29.1213C29.5587 29.6839 28.7956 30 28 30H7C6.20435 30 5.44129 29.6839 4.87868 29.1213C4.31607 28.5587 4 27.7956 4 27V6C4 5.20435 4.31607 4.44129 4.87868 3.87868C5.44129 3.31607 6.20435 3 7 3H28ZM27.25 26.25V18.3C27.25 17.0031 26.7348 15.7593 25.8178 14.8422C24.9007 13.9252 23.6569 13.41 22.36 13.41C21.085 13.41 19.6 14.19 18.88 15.36V13.695H14.695V26.25H18.88V18.855C18.88 17.7 19.81 16.755 20.965 16.755C21.522 16.755 22.0561 16.9762 22.4499 17.3701C22.8438 17.7639 23.065 18.298 23.065 18.855V26.25H27.25ZM9.82 11.34C10.4883 11.34 11.1293 11.0745 11.6019 10.6019C12.0745 10.1293 12.34 9.48835 12.34 8.82C12.34 7.425 11.215 6.285 9.82 6.285C9.14768 6.285 8.50289 6.55208 8.02748 7.02748C7.55208 7.50289 7.285 8.14768 7.285 8.82C7.285 10.215 8.425 11.34 9.82 11.34ZM11.905 26.25V13.695H7.75V26.25H11.905Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_29611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6353,
    height: 30.6353,
    fill: "white",
    transform: "translate(0.269531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinDoodle);
export default __webpack_public_path__ + "static/media/linkedinDoodle.c89e6ea0751fb34d7b2e2d0f99abf02b.svg";
export { ForwardRef as ReactComponent };